import React from "react";

const Trace = ({ questionData }) => {
  const { QuestionImage } = questionData;

  return (
    <div className="flex flex-col select-num-component flex flex-col items-center gap-[50px]">
      {<img className="w-[350px]" src={QuestionImage}></img>}
      <div className="option-list gap-[20px] flex"></div>
    </div>
  );
};

export default Trace;
